import { FormInstance } from 'antd';
import { get } from 'lodash-es';
import { useContext, useEffect } from 'react';

import { ExplorerContext } from '@page/explorer/explorer.provider';
import { getActiveItems, stringReplacer } from '@page/explorer/explorer.util';

import { MethodEnum } from '@enum/method.enum';
import { usePrevious } from '@hook/common/use-previous.hook';
import { isExist, isString } from '@util/data/is-exist';

export const useInitialForm = (schema: any, form: FormInstance) => {
  const { variables, currentEnv } = useContext(ExplorerContext);

  const auth = get(schema, ['request', 'auth'], {});
  const headers = getActiveItems(get(schema, ['request', 'header'], []));
  const body = getActiveItems(get(schema, ['request', 'body', 'formData'], []));
  const params = getActiveItems(get(schema, ['request', 'url', 'variable'], []));
  const query = getActiveItems(get(schema, ['request', 'url', 'query'], []));
  const url = get(schema, ['request', 'url'], {});
  const method = get(schema, ['request', 'method'], MethodEnum.GET);
  const parentId = get(schema, ['parentId'], '');
  const name = get(schema, ['name'], '');

  const prevVariables = usePrevious(variables);

  // useEffect(() => {
  //   const { headers = {}, params = {}, query = {}, body = {} } = form.getFieldsValue();
  //   form.resetFields([
  //     ...Object.keys(headers)
  //       .filter((key) => !isString(variables[key]))
  //       .map((key) => ['headers', key]),
  //     ...Object.keys(params)
  //       .filter((key) => !isString(variables[key]))
  //       .map((key) => ['params', key]),
  //     ...Object.keys(query)
  //       .filter((key) => !isString(variables[key]))
  //       .map((key) => ['query', key]),
  //     ...Object.keys(body)
  //       .filter((key) => !isString(variables[key]))
  //       .map((key) => ['body', key]),
  //   ]);
  // }, [schema]);

  useEffect(() => {
    body.forEach(
      (item: any) =>
        isExist(variables[item.key]) &&
        form.setFieldValue(['body', item.key], stringReplacer(item.value, variables, currentEnv, true)),
    );
    headers.forEach(
      (item: any) =>
        isExist(variables[item.key]) &&
        form.setFieldValue(['headers', item.key], stringReplacer(item.value, variables, currentEnv, true)),
    );
    query.forEach(
      (item: any) =>
        isExist(variables[item.key]) &&
        form.setFieldValue(['query', item.key], stringReplacer(item.value, variables, currentEnv, true)),
    );
    params.forEach(
      (item: any) =>
        isExist(variables[item.key]) &&
        form.setFieldValue(['params', item.key], stringReplacer(item.value, variables, currentEnv, true)),
    );
  }, [schema]);

  useEffect(() => {
    body.forEach((item: any) => {
      if (isExist(variables[item.key])) {
        const value = stringReplacer(item.value, variables, currentEnv, true);
        const prevValue = stringReplacer(item.value, prevVariables ?? {}, currentEnv, true);

        if (prevValue !== value) form.setFieldValue(['body', item.key], value);
      }
    });

    headers.forEach((item: any) => {
      if (isExist(variables[item.key])) {
        const value = stringReplacer(item.value, variables, currentEnv, true);
        const prevValue = stringReplacer(item.value, prevVariables ?? {}, currentEnv, true);

        if (prevValue !== value) form.setFieldValue(['headers', item.key], value);
      }
    });

    query.forEach((item: any) => {
      if (isExist(variables[item.key])) {
        const value = stringReplacer(item.value, variables, currentEnv, true);
        const prevValue = stringReplacer(item.value, prevVariables ?? {}, currentEnv, true);

        if (prevValue !== value) form.setFieldValue(['query', item.key], value);
      }
    });

    params.forEach((item: any) => {
      if (isExist(variables[item.key])) {
        const value = stringReplacer(item.value, variables, currentEnv, true);
        const prevValue = stringReplacer(item.value, prevVariables ?? {}, currentEnv, true);

        if (prevValue !== value) form.setFieldValue(['params', item.key], value);
      }
    });
  }, [body, headers, query, params, prevVariables, variables]);

  useEffect(() => {
    if (auth.type === 'bearer') {
      const authValueKey = get(auth, ['bearer', '0', 'value'], '');
      const value = stringReplacer(authValueKey, variables, currentEnv, true);
      if (isString(value)) form.setFieldValue(['headers', 'Authorization'], `Bearer ${value}`);
    }
  }, [auth, variables]);

  return {
    auth,
    headers,
    body,
    url,
    method,
    parentId,
    name,
    params,
    query,
  };
};
